module.exports = __webpack_public_path__ + "static/media/adminDashboard.e5331bd2.svg";